import React, { useEffect, useState, lazy, Fragment } from "react";
import { Box, Typography } from "@mui/material";
import { Redirect } from "react-router-dom";
import moment from "moment";

import { getCookies, sidebarDrawerInit } from "../../helper/constant";

import { apiURL } from "../../helper/api";
import { Diversity1 } from "@mui/icons-material";
const Sidebar = lazy(() => import("../../component/sidebar"));

const drawerWidth = "260px";

const MainLayout = (props) => {
  const [open, setOpen] = useState(sidebarDrawerInit ? false : true);
  const { innerWidth: width, innerHeight: height } = window;

  const today = new Date();

  useEffect(() => {
    getCookies("token");
  }, [apiURL]);

  return (
    <>
      {/* && getCookies("token") &&  */}
      {window && props.isAuthProtected ? (
        <Box
          className={"page-wrap"}
          style={{ minHeight: "90vh", overflowY: "scroll" }}
        >
          <Sidebar open={open} setOpen={setOpen} window={window} />
          <Box
            style={{
              marginLeft: open ? drawerWidth : width <= 768 ? "30px" : "100px",
            }}
          >
            <div style={{ height: "90vh", position: "relative" }}>
              {props?.component}
            </div>
          </Box>
        </Box>
      ) : (
        <Box style={{ minHeight: "90vh", overflowY: "scroll" }}>
          {!props.isAuthProtected ? (
            <>{props?.component}</>
          ) : (
            <Redirect to="/login" />
          )}
        </Box>
      )}
      <Box
        className={"mx-2"}
        style={{
          bottom: 0,
          position: "relative",
          paddingLeft: props.isAuthProtected ? (open ? drawerWidth : width <= 768 ? "30px" : "100px") : "50px",
        }}
      >
        <Typography className="f-12 f-color-gray mt-3 poppins-font-family">
          Copyright © {moment().year()} EdgeUTech Investor's Kit. All rights
          reserved.
        </Typography>
        <Typography className="f-12 f-color-gray mb-3 poppins-font-family">
          {moment().format('dddd')} - {moment(today).format("LL")}
        </Typography>
      </Box>
    </>
  );
};

export default MainLayout;
